<template>
  <div class="phone-field" v-show="elementActive">
    <div class="col-3 field-label">{{label}}</div>
    <div class="col-7 field-response">
      <div class="row">
        <div class="col-10">
          <input type="phone" maxlength="14" class="form-control" v-model="formattedPhone" :disabled="elementDisabled" />
        </div>
        <div class="col-2 text-end">
          <button class="btn btn-secondary copy-phone" title="Copy phone from Lead Information" @click="copyPhone">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard-plus" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7z"/>
              <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
              <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div class="col-2 field-error">
        {{errors}}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PropsMixin from './FormElementPropsMixin'
import ComputedMixin from './FormElementComputedMixin'
import ProgramSpecificMixin from './ProgramSpecificMixin'

function phoneReplacer (match, p1, p2, p3, offset, string) {
  var output = p1 && p1.length === 3 ? `(${p1})` : `${p1}`
  if (p2) {
    output += ` ${p2}`
  }
  if (p3) {
    output += `-${p3}`
  }
  return output
}

export default {
  name: 'PhoneField',
  mixins: [PropsMixin, ComputedMixin, ProgramSpecificMixin],
  data () {
    return {
    }
  },
  computed: {
    formattedPhone: {
      get () {
        return this.currentValue ? this.currentValue.replace(/(\d{1,3})(\d{0,3})(\d{0,4})/, phoneReplacer) : this.currentValue
      },
      set (phone) {
        if (this.formattedPhone) {
          var oldLength = this.formattedPhone.length
          if (phone && phone.length < oldLength) {
            var currentLastChar = this.formattedPhone.charAt(oldLength - 1)
            if (/\D/.test(currentLastChar)) {
              phone = phone.replace(/\D/g, '')
              phone = phone.slice(0, phone.length - 1)
            }
          }
        }
        this.currentValue = phone ? phone.replace(/\D/g, '') : phone
      }
    },
    ...mapGetters({
      leadInfo: 'consumer/lead/leadInfo'
    })
  },
  methods: {
    copyPhone () {
      this.formattedPhone = this.leadInfo.phone1
    }
  },
  mounted () {
  },
  watch: {
  }
}
</script>

<style scoped>
.copy-phone {
  font-size: 14px;
}
</style>
